// extracted by mini-css-extract-plugin
export default {"listItem":"Competitor_listItem__6XLxj","fieldGroup":"Competitor_fieldGroup__MYZPr"};